<template>
  <div id="statement" v-if="mng">
    <div class="card-body d-flex justify-content-center">
      {{sDate}} - {{eDate}}
       <mdbBtn class=" input-group-text " title='Текущий остаток'>Текущий остаток {{closingBalance}}</mdbBtn>
    </div>
    <div v-if='statement!=undefined' v-for="(payment, index) in statement" :key="index" class="card col-md-12 mb-2 cascading-admin-card" :id=payment.docNum>
      <div class="card-header ">
        {{payment.corrName}}
        <div class="d-flex flex-row-reverse align-self-start">
         <mdbBtn v-bind:class=" {'btn-green': payment.operType==='C', 'btn-red': payment.operType==='D'}"  class=" input-group-text" title='Сумма'>{{payment.amount}}</mdbBtn>
       </div>
       </div>
       <div class="card-body text-sm-left text-lowercase" >
        {{payment.purpose}}
      </div>
    </div>
  </div>
</template>

<script>
import { mdbBtn } from 'mdbvue'
import ApiService from '@/services/ApiService'
// import { ru } from 'date-fns/locale'
// import { formatRelative } from 'date-fns'
import format from 'date-fns/format'
import subDays from 'date-fns/sub_days'
// import addDays from 'date-fns/add_days'
// import differenceInDays from 'date-fns/difference_in_days'
export default {
  name: 'statement',
  components: {
    mdbBtn
  },
  props: ['ai', 'startDate', 'endDate', 'mng'],
  data () {
    return {
      statement: {},
      closingBalance: 0
    }
  },
  watch: {
    startDate () {
      this.getStatement()
    },
    endDate () {
      this.getStatement()
    }
  },
  created () {
  },
  mounted () {
    console.log('STATEMENT MOUNTED')
    this.$emit('DateSelected', {dateone: subDays(Date(), 0), datetwo: subDays(Date(), 0)})
    // this.startDate = subDays(Date(), 0)
    // this.endDate = addDays(Date(), 0)
    this.getStatement()
    /*
    this.$on('DateSelected', (event) => {
      console.log(event)
      this.getStatementEvent(event)
    })
    */
  },
  beforeDestroy () {
  },
  computed: {
    sDate: function () {
      return format(this.startDate, 'DD.MM.YYYY')
    },
    eDate: function () {
      return format(this.endDate, 'DD.MM.YYYY')
    }
  },
  methods: {
    async getStatement () {
      this.statement = {}
      this.closingBalance = 0
      // this.sDate = format(this.startDate, 'D.MM.YYYY')
      // this.eDate = format(this.endDate, 'D.MM.YYYY')
      // console.log(format(this.startDate, 'D.MM.YYYY'))
      let answer = await ApiService.getAlfaStatement(format(this.startDate, 'DD.MM.YYYY'), format(this.endDate, 'DD.MM.YYYY'))
      console.log('getStatement')
      this.statement = answer.data.page
      this.closingBalance = answer.data.statistics.closingBalance
      // console.log(answer.data)
    },
    async getStatementEvent (event) {
      if (this.acti === 10) {
        this.statement = {}
        this.closingBalance = 0
        // this.sDate = format(this.startDate, 'D.MM.YYYY')
        // this.eDate = format(this.endDate, 'D.MM.YYYY')
        // console.log(format(this.startDate, 'D.MM.YYYY'))
        let answer = await ApiService.getAlfaStatement(format(event.dateone, 'DD.MM.YYYY'), format(event.datetwo, 'DD.MM.YYYY'))
        console.log('getStatement EVENT')
        this.statement = answer.data.page
        this.closingBalance = answer.data.statistics.closingBalance
        // console.log(answer.data)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btn-to-top {
    border-radius: 50%;
    padding: 1rem;
    padding-top: 0.9rem;
    padding-right: 1.1rem;
    padding-bottom: 0.9rem;
    padding-left: 1.1rem;
  }
.btn.btn-nav {
    padding: 0.1rem 1.0rem;
    font-size: 0.64rem;
  }
.badge-pill {
    border-radius: 10rem;
    padding-right: 0.6em;
    margin-top: 0.6em;
  }
.form-control:focus {
    border:0px
    }
.form-control {
    height:auto
    }
</style>



// WEBPACK FOOTER //
// src/components/Statement.vue